import React from "react";
import './styles.css'
import CommonScreenContentCenter from "../../../components/screen/common-screen-content-center/commonScreenContentCenter";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import { removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";

const PeformanceMenuScreen = props => {
    let navigate = useNavigate();
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.PERFORMANCE, PERMISSION_SUB_TYPE.PERFORMANCE.VIEW_ALL_EMPLOYEE_PERFORMANCE, employeeSelectedBusiness, employeeSelectedLocation)
    }

    const MENU_OPTIONS = [
        { key: 'REQUESTS', value: removeSpecialCharAndChangeToPascal('REQUESTS') },
        { key: 'FEEDBACKS', value: removeSpecialCharAndChangeToPascal('FEEDBACKS') },
        { key: 'GOALS', value: removeSpecialCharAndChangeToPascal('GOALS') },
        { key: 'MY_TEAM', value: removeSpecialCharAndChangeToPascal('MY_TEAM') },
        ...(isPermissionAllowed() ? [{ key: 'ALL_EMPLOYEES', value: removeSpecialCharAndChangeToPascal('ALL_EMPLOYEES') }] : [])
    ]

    const handleOptionClick = item => {
        switch (item.key) {
            case 'FEEDBACKS':
                navigate(ROUTES.performance.feedbackList, {
                    state: {
                        isFromMenu: true
                    }
                })
                break
            case 'REQUESTS':
                navigate(ROUTES.performance.requestList)
                break
            case 'GOALS':
                navigate(ROUTES.performance.goalList, {
                    state: {
                        isFromMenu: true
                    }
                })
                break
            case 'MY_TEAM':
                navigate(ROUTES.employee.list, {
                    state: {
                        routeType: 'myTeamList',
                        subAction: 'viewGoals',
                        flowType: APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.MY_TEAM
                    }
                })
                break
            case 'ALL_EMPLOYEES':
                navigate(ROUTES.employee.list, {
                    state: {
                        routeType: 'allEmployees',
                        subAction: 'viewGoals',
                        subActionSecond: 'viewFeedback',
                        flowType: APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.EMPLOYEES
                    }
                })
                break
            default:
                break
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Select Option' />
                <div className="pms-option-list-container">
                    {MENU_OPTIONS.map(item => (<div className="pms-ol-item-container" onClick={() => { handleOptionClick(item) }}>
                        <h5 className="pms-oli-label">{item.value}</h5>
                        <div className="pms-oli-img-container">
                            <img src={require('../../../assets/ic_right_icon.png')} className="img" alt="img" />
                        </div>
                    </div>))}
                </div>
            </CommonScreenContent>
        </>
    )
}

export default PeformanceMenuScreen